<template>
  <Transition name="cookie-banner">
    <div
      v-if="visible"
      class="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      role="dialog"
      :aria-label="t('cookie.message')"
    >
      <div class="max-w-5xl mx-auto bg-navy text-white rounded-xl shadow-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie class="shrink-0 w-7 h-7 text-blueberry-light hidden sm:block" aria-hidden="true" />

        <p class="text-sm text-secondary/70 flex-1 leading-relaxed">
          {{ t('cookie.message') }}
          <RouterLink to="/polityka-prywatnosci" class="underline underline-offset-2 text-blueberry-light hover:text-white transition-colors">
            {{ t('cookie.privacyPolicy') }}
          </RouterLink>.
        </p>

        <div class="flex items-center gap-3 shrink-0">
          <button
            @click="decline"
            class="text-sm text-secondary/60 hover:text-white underline underline-offset-2 transition-colors whitespace-nowrap"
          >
            {{ t('cookie.decline') }}
          </button>
          <button
            @click="accept"
            class="bg-blueberry-dark hover:bg-blueberry-dark/80 text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors whitespace-nowrap"
          >
            {{ t('cookie.accept') }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { inject, ref, onMounted } from "vue";
import { RouterLink } from "vue-router";
import { Cookie } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import { enableAnalyticsKey } from "@/lib/analytics";

const { t } = useI18n();
const STORAGE_KEY = "cookie-consent";
const enableAnalytics = inject(enableAnalyticsKey, undefined);

const visible = ref(false);

onMounted(() => {
  if (!localStorage.getItem(STORAGE_KEY)) {
    visible.value = true;
  }
});

async function accept() {
  localStorage.setItem(STORAGE_KEY, "accepted");
  visible.value = false;
  await enableAnalytics?.();
}

function decline() {
  localStorage.setItem(STORAGE_KEY, "declined");
  visible.value = false;
}
</script>

<style scoped>
.cookie-banner-enter-active {
  transition: transform 0.4s ease, opacity 0.4s ease;
}
.cookie-banner-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.cookie-banner-enter-from,
.cookie-banner-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
